import { httpApi } from "./http.api";

export const changePassword = (payload: {
  old_password: string;
  new_password: string;
}): Promise<any> =>
  httpApi
    .post<any>("users/user-custom/change-password/", { ...payload })
    .then(({ data }) => data);

export const getProfile = (): Promise<any> =>
  httpApi.get<any>("/users/user/").then(({ data }) => data);

export const updateProfilePicture = (payload: any): Promise<any> =>
  httpApi
    .patch<any>("/users/user-custom/update-profile-picture/", payload)
    .then(({ data }) => data);

export const cancelSubscription = (payload: any): Promise<any> =>
  httpApi
    .post<any>("/subscription/cancel-subscription/", payload)
    .then(({ data }) => data);

export const getSubscriptionProductList = (): Promise<any> =>
  httpApi.get<any>("/subscription/product-list/").then(({ data }) => data);

export const getSubscriptionPlanList = (): Promise<any> =>
  httpApi.get<any>("/subscription/plans/").then(({ data }) => data);

export const checkoutSubscription = (payload: any): Promise<any> =>
  httpApi
    .post<any>("/subscription/checkout-session/", payload)
    .then(({ data }) => data);

export const getCurrentSubscription = (): Promise<any> =>
  httpApi
    .get<any>("/subscription/current-subscription/")
    .then(({ data }) => data);

export const getBillingHistory = (): Promise<any> =>
  httpApi.get<any>("/subscription/billing-history/").then(({ data }) => data);

export const getSubscriptionProduct = (payload: any): Promise<any> =>
  httpApi
    .get<any>(`/subscription/product-list/?product_id=sinecure_plus`)
    .then(({ data }) => data);

// export const updateSubscriptionPlan = (payload: {
//   plan_id: string;
// }): Promise<any> =>
//   httpApi
//     .post<any>("/subscription/update-subscription-plan/", payload)
//     .then(({ data }) => data);

export const updateSubscriptionPlan = (payload: any): Promise<any> =>
  httpApi
    .post<any>("/subscription/update-subscription-plan/", payload)
    .then(({ data }) => data);

export const getAllInvoice = (): Promise<any> =>
  httpApi
    .get<any>("/subscription/download-all-invoices")
    .then(({ data }) => data);

export const checkPaymentStatus = (): Promise<any> =>
  httpApi
    .get<any>("/subscription/check-payment-status/")
    .then(({ data }) => data);

export const getUpdatePaymentMethodURL = (returnURL: string): Promise<any> =>
  httpApi
    .get<any>(
      "/subscription/update-payment-method/?return_url=" +
      encodeURIComponent(returnURL)
    )
    .then(({ data }) => data);

export const addCard = (formData: FormData): Promise<any> =>
  httpApi.post<any>("subscription/payment-method/add-card/", formData).then(({ data }) => data);

export const deleteCard = (formData: FormData): Promise<any> =>
    httpApi.post<any>("subscription/payment-method/delete-card/", formData).then(({ data }) => data);

export const editCard = (payload: any): Promise<any> =>
    httpApi.post<any>("subscription/payment-method/edit-card/", payload).then(({ data }) => data);
  
export const setDefaultCard = (formData: FormData): Promise<any> =>
    httpApi.post<any>("subscription/payment-method/set-default-card/", formData).then(({ data }) => data);

export const listCards = (): Promise<any> =>
  httpApi.get<any>("subscription/payment-method/list-cards/").then(({ data }) => data);

export const forgotPassword = (payload: {
  email: string;
}): Promise<any> =>
  httpApi
    .post<any>("users/forgot-password/", { ...payload })
    .then(({ data }) => data);

export const resetPassword = (payload: {
  uid: string;
  token: string;
  new_password: string;
}): Promise<any> =>
  httpApi
    .post<any>("users/reset-password/", { ...payload })
    .then(({ data }) => data);
